module.exports = __webpack_public_path__ + "img/USA-Worst-2040 - 2069.e2d17a05.png";